import { useEffect, useState } from "react";
import {
  claimCeremonyOwner,
  createCeremonyOwner,
  releaseCeremonyOwner,
  type CeremonyOwner,
} from "@/lib/webauthn";

export function useCeremonyOwner(): CeremonyOwner {
  const [owner] = useState(createCeremonyOwner);

  useEffect(() => {
    claimCeremonyOwner(owner);
    return () => releaseCeremonyOwner(owner);
  }, [owner]);

  return owner;
}
